import axios from "axios";
import { LOGIN_URL, NO_TOKEN_URL } from "../../constants/helper";

/**
 * Base API URL
 */
export const baseURLNew = "https://apilead.blaccdot.com/api/";

/**
 * Axios Instance
 */
const axiosNew = axios.create({
  baseURL: baseURLNew,
  timeout: 15000,
});

/**
 * Redirect to Login
 */
const redirect_to_login = () => {
  window.location.href = LOGIN_URL;
};

/**
 * REQUEST INTERCEPTOR
 */
axiosNew.interceptors.request.use(
  (config) => {
    // DEBUG: Check if request is triggered
    console.log("Axios Request:", config.method?.toUpperCase(), config.url);

    const url = config.url || "";

    // Skip token for allowed URLs
    const skipToken = NO_TOKEN_URL.some((path) =>
      url.includes(path)
    );

    if (skipToken) {
      return config;
    }

    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No access token found");
      redirect_to_login(); // enable if required
    }

    return config;
  },
  (error) => {
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);

/**
 * RESPONSE INTERCEPTOR
 */
axiosNew.interceptors.response.use(
  (response) => {
    console.log("Axios Response:", response.config.url, response.status);
    return response;
  },
  (error) => {
    console.error(
      "Axios Response Error:",
      error?.response?.status,
      error?.config?.url
    );

    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.clear();
      // redirect_to_login(); // enable if needed
    }

    return Promise.reject(error);
  }
);

export default axiosNew;
